module.exports = __webpack_public_path__ + "static/media/zeposia_ios_pass_mobile.ff04ea47.png";